module.exports = __webpack_public_path__ + "assets/img/anti-pid.39acb779.png";